import { CSSProperties } from 'react';
export enum Evariant {
  contained = 'contained',
  outlined = 'outlined',
}
export enum Eshape {
  box = 'box',
  round = 'round',
}
interface Iprops {
  label: string;
  variant?: Evariant;
  shape?: Eshape;
  className?:string;
  style?: CSSProperties;
  onClick: () => void;
  color?:"primary"|"secondary"
}

const Button = ({
  label,
  variant = Evariant.contained,
  shape = Eshape.box,
  onClick,
  style = {},
  className='',
  color="primary"
}: Iprops) => {
  return (
    <button
      className={`px-3 py-3 font-weignt-600 w-full shape_${shape} ${className}`}
      onClick={onClick}
      style={style}
      data-variant={variant}
      data-color={color}
    >
      {label}
    </button>
  );
};
export default Button;
